import React from 'react'
import { Box, Text, Image, Heading } from 'pcln-design-system'
import { IImageType } from '@pcln/contentful-components'

/**
 * TODO: remove this and use IImageType instead when we upgrade to @pcln/contentful-components v13
 * Bri introduced 4 new fields in IImagetype quality, width, height and fit
 *  */

type IImageTypeTemp = IImageType & {
  quality?: number
  width?: number
  height?: number
  fit?: string
}

function generateFastlyQueryParams(image: IImageTypeTemp) {
  const queryParams = ['fm=webp']

  if (image?.quality) {
    queryParams.push(`q=${image.quality}`)
  }

  if (image?.width) {
    queryParams.push(`w=${image.width}`)
  }

  if (image?.height) {
    queryParams.push(`h=${image.height}`)
  }

  if (image?.fit) {
    queryParams.push(`fit=${image.fit}`)
  }

  return queryParams.join('&')
}

export default function MediaSnippet({
  image,
  heading,
  paragraph
}: {
  image: IImageTypeTemp
  heading?: string
  paragraph?: string
}) {
  const fastlyQueryParams = generateFastlyQueryParams(image)
  return (
    <Box px={2} as="section">
      <Image
        m="auto"
        pb={3}
        src={`${image.asset.file.url}?${fastlyQueryParams}`}
        alt={image.altText}
        loading="lazy"
        height={['440px', null, null, null, null, '500px']}
      />
      {heading && (
        <Heading as="h2" textStyle="heading4" pb={2} m={0} textAlign="center">
          {heading}
        </Heading>
      )}
      {paragraph && (
        <Text pb={3} textStyle="paragraph" textAlign="center">
          {paragraph}
        </Text>
      )}
    </Box>
  )
}
